import { render, staticRenderFns } from "./wechatGroup.vue?vue&type=template&id=735fd6b2&scoped=true"
import script from "./wechatGroup.vue?vue&type=script&lang=js"
export * from "./wechatGroup.vue?vue&type=script&lang=js"
import style0 from "./wechatGroup.vue?vue&type=style&index=0&id=735fd6b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735fd6b2",
  null
  
)

export default component.exports